var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.25 22.248c-3.566 3.566-8.846 4.336-13.166 2.338-.638-.256-1.16-.464-1.658-.464-1.385.008-3.108 1.35-4.004.456-.896-.896.448-2.62.448-4.014 0-.497-.2-1.01-.456-1.65-2-4.32-1.228-9.601 2.338-13.166 4.551-4.553 11.946-4.553 16.498 0 4.56 4.56 4.551 11.948 0 16.5z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.596 14.482h.01M13.919 14.482h.01M9.241 14.482h.01",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgIconChat;